export default __webpack_public_path__ + "6cea328d573bcdb0a76f4b2ff9891691.png";